const textHeader1 = (editor) => {

    editor.BlockManager.add(`textHeader1`, {
        category: 'Typography',
        label: `Heading 1`,
        attributes: { class: 'fa fa-header' },
        content: `<h1>Heading 1 text</h1>`
    });
} 

export default textHeader1;